export default __webpack_public_path__ + "static/media/background1.a021983a.jpg";